import Avvir, { ResponseError } from "avvir";

import makeEventfulAction, { AvvirThunk } from "../make_eventful_action";
import floorBuiltElementCountsLoaded, { FloorBuiltElementCountsLoadedEvent } from "../../events/loaded/projects/floor_built_element_counts_loaded";
import projectNotFound, { ProjectNotFoundEvent } from "../../events/notifications/failure_notifications/project_not_found";
import { FloorBuiltElementCounts } from "../../services/reducers/domain/reduce_floor_built_element_counts";

function loadFloorBuiltElementCounts(projectId: string): AvvirThunk<Promise<FloorBuiltElementCounts>, FloorBuiltElementCountsLoadedEvent | ProjectNotFoundEvent> {
  return (dispatch, getState) => {
    const user = getState().user;

    return Avvir.api.projects.getProjectFloorBuiltElementCounts({ projectId }, user)
      .then((builtElementCounts) => {
        dispatch(floorBuiltElementCountsLoaded(projectId, builtElementCounts));
        return builtElementCounts;
      }).catch((error) => {
        if (error instanceof ResponseError && error.status === 404 && error.message.toLowerCase().includes("project does not exist")) {
          dispatch(projectNotFound());
        } else {
          throw error;
        }
      }) as Promise<FloorBuiltElementCounts>;
  };
}

export default makeEventfulAction("loadFloorBuiltElementCounts", loadFloorBuiltElementCounts);
